<template>
    <div 
        v-if="addresses"
        class="profile-container"
    >  
        <main-title class="mt10 mb16">{{$t('createOrder.title')}}</main-title> 

        <div class="create-order-overlay">
            <create-form/> 
        </div> 
    </div>
</template>

<script>
import mainContainer from '@/components/base/mainContainer';
import mainTitle from '@/components/base/mainTitle';
import createForm from '@/components/forms/orders/createOrder';
import {mapActions, mapGetters} from 'vuex'; 

export default {
    name: 'create-order',
    components: { 
        mainContainer,
        mainTitle,
        createForm 
    },
    computed: {
        ...mapGetters({
            addresses: 'address/addresses' 
        })
    },
    methods: {
        ...mapActions({
            fetch: 'client/fetch',
            fetchServices: 'services/fetch', 
            fetchAddresses: 'address/fetch'
        })
    },
    async mounted() { 
        await this.fetch(); 
        await this.fetchServices();
        await this.fetchAddresses(); 
    }
}
</script>

<style lang="scss" scoped>
.profile-container {
    width: calc(100vw - 310px);
}

@media (max-width: 768px) { 
    .profile-container {
        width: calc(100vw - 42px); 
    }
}

@media (max-width: 568px) { 
    .profile-container {    
        width: calc(100vw - 22px);
    }
}
</style>